/**
 * 系统日志详情页面
 * 创建时间：2017-03-28
 * 创建人：masonchen
 */
<template>
	<div class="ibox float-e-margins ibox-content">
		<div class="form-horizontal">
			<div class="form-group pt20px pr20px">
				<label class="col-sm-1 control-label">日志时间</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="data.reqTime" readonly>
				</div>
				<label class="col-sm-1 control-label">所属一级模块</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="data.menu1Name" readonly>
				</div>
				<label class="col-sm-1 control-label">所属二级模块</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="data.menu2Name" readonly>
				</div>
			</div>
			
			<div class="form-group pr20px">
				<label class="col-sm-1 control-label">操作类别</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="data.operationTypeName" readonly>
				</div>
				<label class="col-sm-1 control-label">操作人</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="data.accountName" readonly>
				</div>
			</div>
			
			<div class="form-group pr20px">
				<label class="col-sm-1 control-label">日志内容</label>
				<div class="col-sm-11" >
					<textarea class="form-control" rows="10" v-model="data.content" readonly/>
				</div>
			</div>
			
			<div class="form-group">
				<div class="col-sm-12 text-center">
					<button class="btn btn-primary" @click="close">关闭</button>
				</div>
		    </div>
		</div>
	</div>	
</template>

<script>
	export default{
		name: "PageLogDetail",
		props: {
			data: {
				default: function(){
					return {
					}
				},
			}
		},
		methods: {
			close(){
				this.$emit('toClose','');
			}
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// PageLogDetail.vue?9a251370